import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { handleAxiosError, notFoundIdHandler } from '@/shared';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { AlertSeverityEnum, UseMutationsParams, UserPost, UserSimple } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';

const { get, post, put } = erpApi();

///* tanSctack query
export const useGetUserById = (id: string) => {
  return useQuery({
    queryKey: ['user', id],
    queryFn: async () => {
      return getUserById(id);
    },
  });
};

///* axios
export const getUserById = async (id: string) => {
  const res = await get<UserSimple>(`${urlBackend}api/v1/user/${id}/`, true);

  notFoundIdHandler(res);

  return res;
};

export const createUserInAdminModule = async (data: UserPost) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await post<UserSimple>(`${urlBackend}api/v1/user/`, data, true);

  setAlert(true, res.message, res.status);
  return res;
};


///* Actualizar informacion del usuario
interface UpdateUserParams {
  id: number
  data: Partial<UserPost>
}

export const useFetchUpdateUser = ({
  enableAlert = false
}: UseMutationsParams) => {

  const setAlert = useUiStore.getState().setAlert;

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ data, id }: UpdateUserParams) => {
      return putUser({ data: data, id: id });
    },
    onSuccess: (data) => {

      console.log(data);

      queryClient.invalidateQueries({ queryKey: ['user'] });

      enableAlert && setAlert(true, data.message, AlertSeverityEnum.success)
    },
    onError: (error) => {

      console.log(error);

      handleAxiosError(error);
    }
  });
};

export const putUser = async ({
  id,
  data,
}: UpdateUserParams) => {
  return put<UserSimple>(`${urlBackend}api/v1/user/${id}/`, data, true);
};
